import React, { useState } from "react";
import { useTranslation } from "react-i18next"; // I18N
import Grid from "@mui/material/Grid";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./style.scss";
import Logo from "../../images/logo2.png";

const LoginPage = (props) => {
  const { t } = useTranslation(); // I18N
  const push = useNavigate();

  const [value, setValue] = useState({
    email: "user@gmail.com",
    password: "123456",
    remember: false,
  });

  const changeHandler = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
    validator.showMessages();
  };

  const rememberHandler = () => {
    setValue({ ...value, remember: !value.remember });
  };

  const [validator] = React.useState(
    new SimpleReactValidator({
      className: "errorMessage",
    }),
  );

  const submitForm = async (e) => {
    e.preventDefault();

    if (validator.allValid()) {
      validator.hideMessages();

      try {
        const response = await axios.post(
          `${
            process.env.REACT_APP_API_BASE_URL ||
            "https://api.caprover.sokaab.com/api"
          }/auth/login`,
          {
            email: value.email,
            password: value.password,
          },
        );

        const { access_token, userData } = response.data;

        localStorage.setItem("access_token", access_token);
        localStorage.setItem("user", JSON.stringify(userData));

        toast.success(t("login.welcome", { name: userData.first_name }));
        window.location.href = "https://dashboard.sokaab.com/";

        setValue({ email: "", password: "", remember: false });
      } catch (err) {
        console.error(err);
        if (err.response && err.response.status === 401) {
          toast.error(t("login.invalidCreds"));
        } else {
          toast.error(t("login.loginFailed"));
        }
      }
    } else {
      validator.showMessages();
      toast.error(t("login.emptyField"));
    }
  };

  return (
    <div className="login-page">
      {/* Left brand panel */}
      <div className="login-left">
        <span className="bubble b1" />
        <span className="bubble b2" />
        <span className="bubble b3" />
        <span className="bubble b4" />
        <div className="login-left-content">
          <img src={Logo} alt="Sokaab" className="login-brand-logo" />
          <h2 className="login-brand-headline">Sokaab</h2>
          <p className="login-brand-tagline">{t("login.tagline")}</p>
        </div>
      </div>

      {/* Right form panel */}
      <div className="login-right">
        <div className="login-right-inner">
          {/* Mobile-only logo */}
          <img src={Logo} alt="Sokaab" className="login-mobile-logo" />

          <h2 className="login-title">{t("login.signIn")}</h2>
          <p className="login-form-subtitle">{t("login.subtitle")}</p>

          <form onSubmit={submitForm}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  className="inputOutline"
                  fullWidth
                  placeholder={t("login.email")}
                  value={value.email}
                  variant="outlined"
                  name="email"
                  label={t("login.email")}
                  InputLabelProps={{ shrink: true }}
                  onBlur={(e) => changeHandler(e)}
                  onChange={(e) => changeHandler(e)}
                />
                {validator.message("email", value.email, "required|email")}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  className="inputOutline"
                  fullWidth
                  placeholder={t("login.password")}
                  value={value.password}
                  variant="outlined"
                  name="password"
                  type="password"
                  label={t("login.password")}
                  InputLabelProps={{ shrink: true }}
                  onBlur={(e) => changeHandler(e)}
                  onChange={(e) => changeHandler(e)}
                />
                {validator.message("password", value.password, "required")}
              </Grid>
              <Grid item xs={12}>
                <Grid className="formAction">
                  <Link to="/forgot">{t("login.forgotPassword")}</Link>
                </Grid>
                <Grid className="formFooter">
                  <Button fullWidth className="cBtnTheme" type="submit">
                    {t("login.login")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
